/** UAE grocery brand — deep flag green chrome + emerald / gold accents. */
export const BRAND = {
  chrome: "#00732F",
  chromeMid: "#065F3C",
  chromeDark: "#004D28",
  primary: "#059669",
  primaryLight: "#34D399",
  primaryDark: "#047857",
  violet: "#CA8A04",
  violetSoft: "#EAB308",
  fresh: "#16A34A",
  freshDark: "#15803D",
  citrus: "#FBBF24",
  citrusDark: "#D97706",
  gold: "#C9A227",
  surface: "#F3FAF6",
  surfaceAlt: "#ECFDF5",
  surfaceBorder: "#D1FAE5",
  white: "#FFFFFF",
  text: "#0F172A",
  textMuted: "#64748B",
  red: "#DC2626",
  redSoft: "#FEE2E2",
  glass: "rgba(255, 255, 255, 0.78)",
  glassBorder: "rgba(5, 150, 105, 0.18)",
  shadow: "0 8px 32px rgba(0, 115, 47, 0.08)",
  shadowLift: "0 16px 48px rgba(5, 150, 105, 0.16)",
};

/** Category icons for grocery POS / catalog (emoji for compact tiles). */
export const CAT_ICONS = {
  Dairy: "🥛",
  Produce: "🥬",
  Bakery: "🍞",
  Meat: "🥩",
  Seafood: "🐟",
  Frozen: "🧊",
  Beverages: "🥤",
  Snacks: "🍿",
  Pantry: "🫙",
  Household: "🧴",
  Personal: "🧼",
  Baby: "👶",
  Health: "💊",
  Default: "🛒",
};

/** Section / nav emoji icons keyed by nav.* label keys. */
export const MENU_EMOJIS = {
  "nav.operations": "⚡",
  "nav.pointOfSale": "🛒",
  "nav.heldBills": "📋",
  "nav.online": "🌐",
  "nav.onlineOrders": "📦",
  "nav.onlineHistory": "🗂️",
  "nav.masters": "📚",
  "nav.categories": "🏷️",
  "nav.products": "🛍️",
  "nav.brands": "🏷️",
  "nav.shelves": "🗄️",
  "nav.areas": "🗺️",
  "nav.units": "📐",
  "nav.customers": "👥",
  "nav.suppliers": "🚛",
  "nav.promotions": "✨",
  "nav.promotionRules": "🎁",
  "nav.priceChanges": "💲",
  "nav.barcodeLabels": "🖨️",
  "nav.inventory": "📦",
  "nav.inventoryHub": "🏠",
  "nav.stockSummary": "📊",
  "nav.batches": "📅",
  "nav.purchaseRequests": "📋",
  "nav.purchaseOrders": "📝",
  "nav.grn": "✅",
  "nav.purchaseDebitNotes": "🧾",
  "nav.transfers": "🔄",
  "nav.adjustments": "⚖️",
  "nav.wrapping": "📦",
  "nav.wastage": "🗑️",
  "nav.supplierReturns": "↩️",
  "nav.inventoryAlerts": "🔔",
  "nav.accounts": "💰",
  "nav.schedules": "📑",
  "nav.accountsChart": "📒",
  "nav.receiptVoucher": "💵",
  "nav.paymentVoucher": "💸",
  "nav.journalVoucher": "📓",
  "nav.contraVoucher": "🔁",
  "nav.debitNote": "🔻",
  "nav.creditNote": "🔺",
  "nav.ledgerReport": "📖",
  "nav.trialBalance": "⚖️",
  "nav.profitLoss": "📈",
  "nav.balanceSheet": "🧮",
  "nav.cashBook": "💴",
  "nav.bankBook": "🏦",
  "nav.dayBook": "📆",
  "nav.reports": "📑",
  "nav.reportCenter": "📊",
  "nav.misReports": "📈",
  "nav.administration": "⚙️",
  "nav.users": "👤",
  "nav.roles": "🛡️",
  "nav.auditLog": "🕵️",
  "nav.counters": "🖥️",
  "nav.loyalty": "🎁",
  "nav.denominations": "🪙",
  "nav.weighingMachines": "⚖️",
  "nav.imei": "📱",
  "nav.printers": "🖨️",
  "nav.companySetup": "🏢",
  "nav.storeSetup": "🏪",
  "nav.taxSettings": "🧾",
  "nav.generalSettings": "🔧",
  "nav.onlineStore": "🛒",
  "nav.dashboard": "🏠",
};

export function getCatIcon(name) {
  if (!name) return CAT_ICONS.Default;
  const key = Object.keys(CAT_ICONS).find((k) => name.toLowerCase().includes(k.toLowerCase()));
  return key ? CAT_ICONS[key] : CAT_ICONS.Default;
}

export function getMenuEmoji(labelKey) {
  return MENU_EMOJIS[labelKey] || "•";
}

/** Retail POS action button styles. */
export const POS_ACTION_STYLES = {
  hold: { bg: "#FEF3C7", border: "#F59E0B", text: "#92400E" },
  recall: { bg: "#D1FAE5", border: "#059669", text: "#065F46" },
  reprint: { bg: "#E0E7FF", border: "#6366F1", text: "#3730A3" },
  void: { bg: "#FEE2E2", border: "#EF4444", text: "#991B1B" },
  discount: { bg: "#FEF9C3", border: "#CA8A04", text: "#854D0E" },
  return: { bg: "#FEE2E2", border: "#F87171", text: "#991B1B" },
  credit: { bg: "#F1F5F9", border: "#94A3B8", text: "#334155" },
  clear: { bg: "#FEE2E2", border: "#EF4444", text: "#991B1B" },
  drawer: { bg: "#D1FAE5", border: "#34D399", text: "#065F46" },
};
